import { render, staticRenderFns } from "./bloodFollowUpDetail.vue?vue&type=template&id=30d63832&scoped=true"
import script from "./bloodFollowUpDetail.vue?vue&type=script&lang=js"
export * from "./bloodFollowUpDetail.vue?vue&type=script&lang=js"
import style0 from "./bloodFollowUpDetail.vue?vue&type=style&index=0&id=30d63832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d63832",
  null
  
)

export default component.exports